module.exports = __webpack_public_path__ + "img/honor2.7217da93.png";